import React from "react";
import { Link } from "react-router-dom";

const Heropage = () => {
  const backgroundImage = "/images/home.jpg"; // Update with the correct path

  return (
    <>
      <div
        className="relative bg-cover bg-center min-h-max md:min-h-screen"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
        }}
      >
        <section className="text-white body-font ">
          <div className="container md:mt-16 mr-28 md:mr-0 mx-auto flex items-center justify-items-start md:justify-center px-0 md:px-5 py-24 md:flex-row flex-col relative z-10">
            <div className="lg:flex-grow pr-36 pt-10 md:p-3 md:mt-20 md:ml-20  lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
              <h1 className="text-1xl font-bold mb-2 text-amber-500">
                // The Best Bakery
              </h1>

              <h2 className="md:text-7xl mb-6 text-3xl p-2 w-full md:w-full   font-hero line-height-6 text-custom-80">
                We Bake With Passion
              </h2>
              <p className=" w-full mb-6 text-lg pb-3">
                Indulge in our mouth-watering cakes made with love and passion.
              </p>

              <div className="flex justify-center mb-8 animate__animated animate__fadeIn animate__delay-3s">
                <Link to="/cake">
                  <button className="bg-amber-400 p-2 md:p-3 lg:p-4 hover:bg-blue-700 text-white font-bold py-3 px-5 md:py-4 md:px-6 lg:py-5 lg:px-7 rounded-full">
                    Read more
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Scrolling Down Animation */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
          <Link to="/menu">
            <div className="scroll-down animate__animated animate__bounce animate__infinite animate__delay-4s">
              <div className="chevron"></div>
              <div className="chevron"></div>
              <div className="chevron"></div>
            </div>
          </Link>
        </div>
      </div>

      {/* Slogan Section */}
      <section className="bg-gradient-to-r  from-gray-800 via-gray-700 to-gray-600 text-white md:py-12 py-2">
        <div className="container mx-auto text-center">
          <h2 className="text-lg font-semibold mb-4">
            Delicious Cakes Just for You
          </h2>
          <p className="text-lg">
            Indulge in our mouth-watering cakes made with love and passion.
          </p>
        </div>
      </section>
    </>
  );
};

export default Heropage;

// import React from "react";
// import { Link } from "react-router-dom";

// const Heropage = () => {
//   const backgroundImage = "/images/home.jpg"; // Update with the correct path

//   return (
//     <>
//       <div
//         className="relative bg-cover bg-center min-h-max md:min-h-screen "
//         style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover' }}
//       >
//         <div className="absolute inset-0 flex h-full items-center justify-start md:ml-28 mt-24">
//       <div className="text-white text-left p-5 ">
//         <h1 className="text-1xl font-bold mb-2">"// The Best Bakery"</h1>
//         <h2 className="md:text-7xl text-1xl p-2   font-hero line-height-6 text-custom-80">We Bake With Passion</h2>
//         <p className="text-lg mb-4 pb-3">dgfdgdfg</p>
//         <button className="bg-amber-400 p-2 md:p-3 lg:p-4 hover:bg-blue-700 text-white font-bold py-3 px-5 md:py-4 md:px-6 lg:py-5 lg:px-7 rounded-full">
//           Read more
//         </button>
//       </div>
//     </div>

//         {/* Scrolling Down Animation */}
//         <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
//           <Link to="/menu">
//             <div className="scroll-down animate__animated animate__bounce animate__infinite animate__delay-4s">
//               <div className="chevron"></div>
//               <div className="chevron"></div>
//               <div className="chevron"></div>
//             </div>
//           </Link>
//         </div>
//       </div>

//       {/* Slogan Section */}
//       <section className="bg-gradient-to-r from-gray-800 via-gray-700 to-gray-600 text-white py-12">
//         <div className="container mx-auto text-center">
//           <h2 className="text-3xl font-bold mb-4">Delicious Cakes Just for You</h2>
//           <p className="text-lg">
//             Indulge in our mouth-watering cakes made with love and passion.
//           </p>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Heropage;
